import { makeStyles } from 'tss-react/mui';

export default makeStyles()((theme) => ({
  /** 24px mobile / 48px desktop — between post grid and ad, and between chunk sections */
  chunkGap: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      gap: theme.spacing(6),
    },
  },
  gridContainer: {
    // Padding removed - spacing handled by parent containers
  },
  centeredContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  contentHeight: {
    height: '100px',
  },
  loadMoreButtonContainer: {
    marginTop: theme.spacing(3),
  },
  loadingMoreContainer: {
    width: '100%',
    marginTop: theme.spacing(9),
  },
  skeletonContainer: {
    minHeight: '400px',
    height: '100%',
    minWidth: '100%',
    maxWidth: '100%',
  },
  loadMoreButton: {
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: theme.palette.text.primary,
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      borderColor: theme.palette.text.primary,
    },
    '&.Mui-disabled': {
      borderColor: theme.palette.action.disabled,
      color: theme.palette.action.disabled,
    },
  },
}));
